'use strict';

/*global isEmpty*/
/*global blockElement*/
/*global unBlockElement*/
/*global services*/
function WinsModal(id) {
    this.id = id;
    this.opened = false;
    this.$modal = null;
    this.setting = null;
    this.defaultSetting = null;
    
    this.init();
}

WinsModal.prototype = $.extend({}, {
    construtor: 'WinsModal', 
    
    //**************************************************************************    
    //**************************************************************************

    registerCallbacks: function registerCallbacks() {
        var _this = this;

        var scrollHandler = function () {
            if (!isEmpty(_this.setting.scrollCallback)) {
                if (_this.setting.scrollCallback) {
                    if ($.isFunction(_this.setting.scrollCallback)) {
                        _this.setting.scrollCallback();
                    } else {
                        window[_this.setting.scrollCallback]();
                    }
                }
            }

            _this.$modal.trigger('scrollModal');
        };

        var submitHandler = function () {
            if (!isEmpty(_this.setting.formSubmitCallback)) {
                if ($.isFunction(_this.setting.formSubmitCallback)) {
                    _this.setting.formSubmitCallback();
                } else {
                    window[_this.setting.formSubmitCallback]();
                }
            }

            return false;
        };

        var backHandler = function () {
            if (!isEmpty(_this.setting.formBackCallback)) {
                if ($.isFunction(_this.setting.formBackCallback)) {
                    _this.setting.formBackCallback();
                } else {
                    window[_this.setting.formBackCallback]();
                }
            }

            return false;
        };

        var enterSubmitHandler = function (e) {
            var keyCode = e.originalEvent.keyCode || e.originalEvent.which || e.originalEvent.charCode || e.originalEvent.code;

            if (keyCode === 13) {
                if (!isEmpty(_this.setting.formEnterSubmitCallback)) {
                    if ($.isFunction(_this.setting.formEnterSubmitCallback)) {
                        _this.setting.formEnterSubmitCallback();
                    } else {
                        window[_this.setting.formEnterSubmitCallback]();
                    }

                    return false;
                }
            }
        };

        var openHandler = function () {
            if (!isEmpty(_this.setting.openCallback)) {
                if ($.isFunction(_this.setting.openCallback)) {
                    _this.setting.openCallback();
                } else {
                    window[_this.setting.openCallback]();
                }
            }

            return false;
        };

        _this.$modal.find('.modal-body').bind('scroll', scrollHandler);
        _this.$modal.find('.modal-footer .submit').bind('click', submitHandler);
        _this.$modal.find('.modal-footer .back').bind('click', backHandler);
        _this.$modal.find('.modal-body').on('keydown', 'input:text', enterSubmitHandler);
        _this.$modal.bind('shown.bs.modal', openHandler);
    },

    setModalParams: function setModalParams() {
        var _this = this;

        _this.$modal.attr('class', 'modal fade');
        if (!isEmpty(_this.$modal.data('modal_class'))) {
            _this.$modal.removeClass(_this.$modal.data('modal_class'));
        }

        if (!isEmpty(_this.setting.modalClass)) {
            _this.$modal.addClass(_this.setting.modalClass);
            _this.$modal.data('modal_class', _this.setting.modalClass);
        }

        _this.$modal.find('.modal-header').attr('class', 'modal-header');
        _this.$modal.find('.modal-header').addClass(_this.setting.headerClass);
        _this.$modal.find('.modal-title').html(_this.setting.title);
        _this.$modal.find('.modal-body').html(_this.setting.content);
        _this.$modal.find('.modal-body').css('overflow-y', 'auto');
    },

    setModalForm: function setModalForm(isForm) {
        var _this = this;

        _this.setting.form = isForm;

        _this.$modal.find('.modal-footer .submit').hide();
        _this.hideBackBtn();

        if (_this.setting.form) {
            _this.$modal.find('.modal-footer .submit').attr('class', 'btn submit');
            _this.$modal.find('.modal-footer .submit').addClass(_this.setting.formSubmitBtnClass);
            _this.$modal.find('.modal-footer .submit').text(_this.setting.formSubmitBtnTitle);
            _this.$modal.find('.modal-footer .submit').show();

            _this.$modal.find('.modal-footer .back').attr('class', 'btn back');
            _this.$modal.find('.modal-footer .back').addClass(_this.setting.formBackBtnClass);
            _this.$modal.find('.modal-footer .back').text(_this.setting.formBackBtnTitle);

            if (_this.setting.formBackVisible) {
                _this.showBackBtn();
            }
        }
    },

    setModalDimensions: function setModalDimensions() {
        var _this = this;
        
        _this.$modal.find('.modal-body').css('max-height', $(window).height() * 0.7);

        if (_this.setting.minHeight) {
            _this.$modal.find('.modal-body').css('min-height', _this.setting.minHeight);
        } else {
            _this.$modal.find('.modal-body').css('min-height', 'auto');
        }

        if (_this.setting.height) {
            _this.$modal.find('.modal-body').css('max-height', _this.setting.height);
          _this.$modal.find('.modal-body').css('height', _this.setting.height);
        } else {
            _this.$modal.find('.modal-body').css('max-height', $(window).height() * 0.7);
            _this.$modal.find('.modal-body').css('height', $(window).height() * 0.7);
        }
        _this.$modal.find('.modal-body').css('overflow-y', 'auto');

        _this.width(_this.setting.width);
    },

    open: function open(setting) {
        var _this = this;

        _this.setting = $.extend({}, _this.defaultSetting, setting);

        _this.setModalParams();
        _this.setModalForm(_this.setting.form);
        _this.setModalDimensions();

        _this.$modal.modal({ backdrop: 'static', keyboard: _this.setting.keyboardClose });
        _this.$modal.modal('show');
        _this.unBlock();
        _this.setFocus();
        _this.content(_this.setting.content);
        _this.opened = true;

        return _this;
    },

    close: function close() {
        var _this = this;

        _this.$modal.modal('hide');
        _this.opened = false;

        return _this;
    },

    content: function content(content) {
        var _this = this;

        if (!isEmpty(content)) {
          _this.$modal.find('.modal-body').html(content);
          _this.setFocus();
        }

        return _this.$modal.find('.modal-body').html();
    },

    contentDOM: function contentDOM() {
        var _this = this;

        return _this.$modal.find('.modal-body');
    },

    empty: function empty() {
        var _this = this;

        _this.$modal.find('.modal-body').html('');

        return _this;
    },
    
    submit: function submit() {
        var _this = this;
        
        if(!isEmpty(_this.setting.formSubmitCallback)) {
            _this.setting.formSubmitCallback();
        }
    },

    back: function back() {
        var _this = this;
        
        if(!isEmpty(_this.setting.formBackClb)) {
            _this.setting.formBackClb();
        }
    },

    isOpen: function isOpen() {
        var _this = this;

        return _this.opened;
    },

    block: function block() {
        var _this = this;

        _this.$modal.find('.modal-footer .submit').attr('disabled', true);
        blockElement(_this.$modal.find('.modal-body'));

        return _this;
    },

    unBlock: function unBlock() {
        var _this = this;

        _this.$modal.find('.modal-footer .submit').removeAttr('disabled');
        unBlockElement(_this.$modal.find('.modal-body'));

        return _this;
    },

    setFocus: function setFocus(forceFocus) {
        var _this = this;

        forceFocus = forceFocus || false;

        if (_this.setting.focusInput || forceFocus) {
            setTimeout(function () {
                _this.contentDOM().find('input:text, textarea').filter(':first').focus();
            }, 300);
        }

        return _this;
    },

    width: function width(width) {
        var _this = this;

        var $modalDialog = _this.$modal.find('.modal-dialog');
        if (!isEmpty($modalDialog.data('width'))) {
          $modalDialog.removeClass($modalDialog.data('width'));
        }

        if (!isEmpty(width)) {
          $modalDialog.data('width', width);
          $modalDialog.addClass('modal-' + width);
        }

        return _this;
    },

    title: function title(title) {
        var _this = this;

        _this.$modal.find('.modal-title').text(title);

        return _this;
    },

    showBackBtn: function showBackBtn() {
        var _this = this;

        _this.$modal.find('.modal-footer .back').show();

        return _this;
    },

    hideBackBtn: function hideBackBtn() {
        var _this = this;

        _this.$modal.find('.modal-footer .back').hide();

        return _this;
    },

    defineWinsModalSetting: function defineWinsModalSetting() {
        var _this = this;

        _this.defaultSetting = $.extend({}, {
            title: services.get('translator').trans('Title'),
            width: 'md',
            height: $(window).height() * 0.7,
            minHeight: null,
            modalMargin: 10,
            modalClass: '',
            content: '',
            scrollCallback: null,
            openCallback: null,
            focusInput: false,
            form: false,
            formBackBtnClass: 'btn-warning',
            formBackBtnTitle: services.get('translator').trans('Back'),
            formBackCallback: null,
            formBackVisible: false,
            formSubmitBtnClass: 'btn-primary',
            formSubmitBtnTitle: services.get('translator').trans('FormSave'),
            formSubmitCallback: null,
            formEnterSubmitCallback: null
        });
    },

    //**************************************************************************    
    init: function init() {
        var _this = this;

        _this.defineWinsModalSetting();

        var modalStr  = '<div class="modal fade ' + _this.defaultSetting.modalClass + '" tabindex="-1" role="dialog" id="' + _this.id + '">';
        modalStr += '<div class="modal-dialog" role="document">';
        modalStr += '<div class="modal-content">';
        modalStr += '<div class="modal-header ' + _this.defaultSetting.headerClass + '">';
        modalStr += '<button type="button" class="close" data-dismiss="modal" aria-label="' + services.get('translator').trans('ModalClose') + '"><span aria-hidden="true">&times;</span></button>';
        modalStr += '<h4 class="modal-title">' + _this.defaultSetting.title + '</h4>';
        modalStr += '</div>';
        modalStr += '<div class="modal-body">' + _this.defaultSetting.content + '</div>';
        modalStr += '<div class="modal-footer">';
        modalStr += '<button type="button" class="btn btn-default pull-left" data-dismiss="modal">' + services.get('translator').trans('ModalClose') + '</button>';
        modalStr += '<button type="button" class="btn back ' + _this.defaultSetting.formBackBtnClass + '" style="' + (!_this.defaultSetting.formBackVisible ? 'display: none;' : '') + '">' + _this.defaultSetting.formBackBtnTitle + '</button>';
        modalStr += '<button type="button" class="btn submit ' + _this.defaultSetting.formSubmitBtnClass + '">' + _this.defaultSetting.formSubmitBtnTitle + '</button>';
        modalStr += '</div>';
        modalStr += '</div>';
        modalStr += '</div>';
        modalStr += '</div>';

        _this.$modal = $(modalStr);

        $('body').append(_this.$modal);

        _this.registerCallbacks();
      } 
});
